module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Hausen_AG-da8a2a71a31a01a6592b24956d606894.svg";